import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import Hero from "./components/Hero";
import TrustSection from "./components/TrustSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import ArticleCards from "./components/ArticleCards";
import FAQSection from "./components/FAQSection";
import Testimonial from "./components/Testimonial";
import CTASection from "./components/CTASection";
import { faqItems } from "@/mocks/articles";

const SITE_URL = "https://kakobuyspreadsheet.watch";

const homeJSONLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Kakobuy Spreadsheet Polska",
  "url": SITE_URL,
  "description": "Najlepsza polska baza produktów Kakobuy — zweryfikowane linki, codzienna aktualizacja, bezpieczne zakupy z Chin.",
  "inLanguage": "pl-PL",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const faqJSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqItems.map((item) => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="Najlepszy Kakobuy Spreadsheet Polska 2026 — Baza Produktów z Chin"
        description="Kakobuy Spreadsheet to najlepsza baza produktowa dla Polaków — agregujemy setki zweryfikowanych ofert z Chin. Sprawdź kategorie Shoes, Hoodies, T-Shirts, Jackets, Bags i zamów bezpiecznie przez kaspreadsheet.com. Codzienna aktualizacja 2026."
        keywords="kakobuy spreadsheet, spreadsheet kakobuy, kakobuy finds, kakobuy links, kakobuy yupoo, polska baza produktów, zakupy chiny"
        canonicalPath="/"
        ogType="website"
        jsonLd={[homeJSONLD, faqJSONLD]}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <CategoryGrid />
        <ComparisonSection />
        <ArticleCards />
        <FAQSection />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}